/**
 * Utility functions for handling Shopify IDs
 */

/**
 * Type for Shopify entity types
 */
export type ShopifyIdType =
  | 'Product'
  | 'ProductVariant'
  | 'Order'
  | 'Customer'
  | 'Cart'
  | 'Collection'
  | string;

/**
 * Formats a simple ID into the Shopify GraphQL ID format
 *
 * @param type - The Shopify entity type
 * @param id - The ID to format
 * @returns The formatted Shopify GraphQL ID
 */
export const getFormattedShopifyId = (type: ShopifyIdType, id: string): string => {
  if (id.includes(`gid://shopify/${type}/`)) {
    return id;
  }
  return `gid://shopify/${type}/${id}`;
};

/**
 * Extracts the numeric ID from a formatted Shopify GraphQL ID
 *
 * @param id - The formatted Shopify ID (gid://shopify/Type/1234) or numeric ID
 * @returns The extracted ID as a string
 */
export const getIdFromShopifyFormattedId = (id: string | number): string => {
  if (typeof id === 'number') return id.toString();
  return id.split('/').pop() || '';
};
